import { combineEpics } from "redux-observable";
import { analysisStudyListEpics } from "./Analysis/epics/AnalysisStudyListEpic.js";
import { provideAnalysisStudyWriteEpics } from "./Analysis/epics/AnalysisStudyWriteEpic.js";
import { analysisStudyLogPerformanceEpics } from "./Analysis/epics/AnalysisStudyLogPerformanceEpics.js";
import "./AnalysisCreate/epics/AnalysisCreate.epics.js";
import analysisEditEpics from "./Analysis/components/AnalysisEdit/AnalysisEdit.epics.js";
import { provideAnalysisTaskEpics } from "./Analysis/epics/AnalysisTaskEpic.js";
import AnalysisCreateContainerEpic from "./AnalysisCreate/components/AnalysisCreateContainer/AnalysisCreateContainer.epics.js";
const analysisEpics = combineEpics(
  analysisStudyListEpics,
  provideAnalysisStudyWriteEpics(),
  analysisStudyLogPerformanceEpics,
  AnalysisCreateContainerEpic,
  provideAnalysisTaskEpics(),
  analysisEditEpics
);
export {
  analysisEpics as default
};
//# sourceMappingURL=epics.js.map
